<template>
    <VueFinalModal class="comment-modal" content-class="modal-content" content-transition="vfm-slide-up">
        <div class="dialog-content">
            <span>Admin Lock/Unlock selected and Approved ({{ props.users.length }}) {{ props.users.length == 1 ? 'user' : 'users' }}</span>
            <div class="user-list">
                <div v-for="usr in props.users" :key="usr.userItem.id">
                    <div class="user-item">{{ usr.userItem.fullName }} ({{ usr.userItem.email }})</div>
                </div>            
            </div>
            <div class="buttons">
                <button @click="() => emit('close')">Cancel</button>
                <button class="accent" @click="() => emit('lock')" v-if="!hasOnlyLockedUsers()">Lock</button>
                <button class="accent" @click="() => emit('unlock')" v-if="!hasOnlyUnlockedUsers()">Unlock</button>
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
import { UserApproval } from "@/services/entities/Approval/UserApproval";
import { defineProps, defineEmits } from "vue";
import { VueFinalModal } from "vue-final-modal";

const props = defineProps<{
  users: UserApproval[]
}>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "lock"): void;
  (e: "unlock"): void;
}>();

function hasOnlyUnlockedUsers(): boolean {
  return props.users.every(u => !u.monthlyApprovalItem?.isLocked);
}

function hasOnlyLockedUsers(): boolean {
  return props.users.every(u => u.monthlyApprovalItem?.isLocked);
}

</script>

<style scoped lang="scss">
.user-list {
    margin-top: 10px;
    margin-bottom: 10px;
    max-height: 400px;
    overflow-y: auto;
}
.user-item {
    font-size: small;
}
</style>